import { Component, Input } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { Goal } from '@models/performance/goal.model';

@Component({
    selector: 'app-form-goal',
    templateUrl: './goal.template.html',
})
export class GoalForm extends BaseForm {
    @Input() goal: Goal;

    addMilestone(): void {
        this.goal.metricMilestones.push({
            label: null,
            description: null,
            editMode: true,
        });
    }

    removeMilestone(index: number): void {
        this.goal.metricMilestones.splice(index, 1);
    }

    metricTypeChange(valueType: any): void {
        if (this.goal.metricType === valueType) {
            return;
        }

        this.goal.metricType = valueType;

        if (valueType !== 'milestones') {
            this.goal.metricMilestones = [];
        }

        if (valueType === 'percent') {
            this.goal.metricValue = 100;
            return;
        }

        if (valueType === 'binary') {
            this.goal.metricValue = 1;
            return;
        }

        if (valueType === 'number') {
            this.goal.metricValue = null;
            return;
        }

        // only reset if there are no milestones
        if (valueType === 'milestones' && !this.goal.metricMilestones.length) {
            this.goal.metricValue = 100;
            this.goal.metricMilestones = [];
            return;
        }

        if (valueType === 'dollar') {
            this.goal.metricValue = 0;
        }
    }
}
